export enum FlexDirection {
  // Flow will be vertical
  COLUMN = 'column',
  // Flow will be horizontal
  ROW = 'row',
}

export enum FlexAlignment {
  START = 'flexStart',
  END = 'flexEnd',
  CENTER = 'center',
}
